/**
 * Ручной сбор казны соты (§Т2.2 POST /map/hex/:hexId/collect).
 */

import { apiFetch } from "./client.js";
import type { ServerWalletView } from "./wallet.js";

export type CollectResult = {
  readonly hexId: string;
  readonly collected: number;
  readonly wallet: Pick<ServerWalletView, "hive" | "debt" | "held" | "effective">;
};

export async function collectVault(
  hexId: string,
  token: string,
  idempotencyKey: string,
): Promise<CollectResult> {
  return apiFetch<CollectResult>(`/map/hex/${hexId}/collect`, {
    method: "POST",
    token,
    headers: { "Idempotency-Key": idempotencyKey },
    body: JSON.stringify({}),
  });
}
